<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="公司名称">
          <el-input placeholder="请输入公司名称" v-model="input"></el-input>
        </el-form-item>

        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <span
        class="attention margin-top10 margin-bot10 margin-left20 margin-right20"
        @click="toCertifiedbusiness()"
        >新 增</span
      >
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20 pad-top20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="page"
            stripe
            style="width: 98%"
            class="eltable margin-auto f14"
          >
            <el-table-column label="企业名称" align="left">
              <template slot-scope="scope"
                ><span class="bluecolor">{{
                  scope.row.company
                }}</span></template
              ></el-table-column
            >
            <el-table-column label="用户角色" align="center">
              <template slot-scope="scope"
                ><span>{{ scope.row.authority }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="实名认证状态"
              align="center"
              prop="status"
            />
            <el-table-column
              label="企业认证时间"
              align="center"
              prop="create_time"
            />
            <el-table-column
              label="操作"
              align="center"
              width="220"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="Setasdefault(scope.row)"
                  >设为默认</span
                >
                <span
                  class="f14 cursorpointer bluecolor margin-left10"
                  @click="downloadreport(scope.row)"
                  >取消绑定
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import { boundEnterprise, boundchange } from "@/api/personal/personal.api";
import { bindquit } from "@/api/loader/loder.api";

import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      ruleForm: {
        pipo: "",
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progres: { background: "red" },
      progress: "",
      rules: {
        pipo: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
      },
      serchkey: true,
      input: "",
    };
  },

  components: {
    callback,
    switchcore,
  },
  methods: {
    // 新增
    toCertifiedbusiness() {
      this.$router.push({ path: "/Personal-Center/Enterprise-Certification" });
    },
    submitForm() {
      if (this.input != "") {
        // // 获取企业
        boundEnterprise({ _keywords: this.input, page: 1 }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.pagination = true;
            window.sessionStorage.setItem("titlebusiness", this.ruleForm.pipo);
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        return;
      }
    },

    // 取消绑定
    downloadreport(row) {
      this.$confirm("此操作将取消绑定该企业, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          bindquit({ id: row.ent_id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.drawer = false;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 设为默认
    Setasdefault(row) {
      boundchange({ id: row.ent_id }).then((res) => {
        if (res.data.code == 200) {
          BUS.$emit("send", row.company);
          this.refresh();
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      boundEnterprise({
        _keywords: this.ruleForm.pipo,
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "访客";
            }
            if (i.status == 1) {
              i.status = "未实名认证";
            } else if (i.status == 2) {
              i.status = "实名认证中";
            } else {
              i.status = "已实名认证";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      boundEnterprise({
        _keywords: this.ruleForm.pipo,
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "访客";
            }
            if (i.status == 1) {
              i.status = "未实名认证";
            } else if (i.status == 2) {
              i.status = "实名认证中";
            } else {
              i.status = "已实名认证";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      // // 获取企业
      boundEnterprise().then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "访客";
            }
            if (i.status == 1) {
              i.status = "未实名认证";
            } else if (i.status == 2) {
              i.status = "实名认证中";
            } else {
              i.status = "已实名认证";
            }
          });
          this.pagination = true;
          window.sessionStorage.setItem("titlebusiness", this.ruleForm.pipo);
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      boundEnterprise({
        _keywords: this.ruleForm.pipo,
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "访客";
            }
            if (i.status == 1) {
              i.status = "未实名认证";
            } else if (i.status == 2) {
              i.status = "实名认证中";
            } else {
              i.status = "已实名认证";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    window.sessionStorage.setItem("default", "个人中心");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    boundEnterprise({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.authority == 1) {
            i.authority = "管理员";
          }
          if (i.authority == 2) {
            i.authority = "访客";
          }
          if (i.status == 1) {
            i.status = "未实名认证";
          } else if (i.status == 2) {
            i.status = "实名认证中";
          } else {
            i.status = "已实名认证";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.all-title {
  height: 56px;
  line-height: 56px;
}
.patenbtn {
  background: #678feb;
  color: #f9f9f9;
  padding: 2px 10px 2px 10px;
}
.Tablename {
  background: #dfdfdf;
  color: #b0b0b0;
}
.Tableconts {
  background: #efefef;
  border-bottom: 1px solid #efefef;
}
.Tablecont {
  border-bottom: 1px solid #efefef;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.progress {
  height: 10px;
}
.addproject {
  width: 100px;
  color: white;
  background: #0039bf;
  border-radius: 5px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
</style>